import { Stack } from 'expo-router'
import { platformStackAnimation } from '../../../../lib/navigation/stable-stack-options'

// Verification is a forward-progression flow: hub → provider-backed step.
// Native gets `slide_from_right` to reinforce that progression (same on iOS
// and Android — by default Android fades, which feels like lateral nav and
// undermines the "you're going through steps" mental model). Web stays
// instant to avoid SPA hydration flicker.
export default function VerificationLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        animation: platformStackAnimation('slide_from_right'),
      }}
    />
  )
}
